import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import classnames123 from "classnames";
import { useParams } from "react-router";
import { DebounceInput } from "react-debounce-input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Nav, NavItem, NavLink, TabPane, TabContent } from "reactstrap";

import {
  tabsNames,
  BRAND_GROUPS_LABELS,
  LIST_SEARCH_DEBOUNCE_MS,
  PAGINATION_INDEXING,
  EMPTY_ARRAY_LENGTH,
} from "../../constants";
import {
  groupsActions,
  individualStoreProfileActions,
} from "../../redux/actions";
import { managersActions } from "../../../group-screens/redux/actions";
import { storeActions } from "../../../admin-screens/redux/actions";
import GroupsTab from "./groupsTab";
import ManagersTab from "./managersTab";
import { onKeyDownHandler } from "../../../../shared";
import {
  createListDefaultQuery,
  resetListSearchQuery,
  applyListSearchQuery,
} from "../shared/listPaginationUtility";

const BrandGroups = (props) => {
  const {
    getStoreById,
    emptyAllGroups,
    emptyAllManagers,
    getGroupsByBrandId,
    getManagersByBrandId,
    resetRestaurantProfile,
  } = props;

  const { brandId } = useParams();

  // Initialize states.
  const firstUpdate = useRef(true);
  const [groups, setGroups] = useState([]);
  const [queryString, setQueryString] = useState(createListDefaultQuery);
  const [managersQueryString, setManagersQueryString] = useState(
    createListDefaultQuery
  );
  const [managers, setManagers] = useState([]);
  const [activeTab, setActiveTab] = useState(tabsNames.group);

  //Set query string
  const setSearch = () => {
    if (activeTab === tabsNames.group) {
      emptyAllGroups();
      setGroups([]);
      setQueryString((prevQueryString) =>
        resetListSearchQuery(prevQueryString)
      );
    } else {
      emptyAllManagers();
      setManagers([]);
      setManagersQueryString((prevQueryString) =>
        resetListSearchQuery(prevQueryString)
      );
    }
  };

  //Set search string state value
  const setSearchString = (e) => {
    const searchValue = e.target.value;
    if (activeTab === tabsNames.group) {
      emptyAllGroups();
      setGroups([]);
      setQueryString((prevQueryString) =>
        applyListSearchQuery(prevQueryString, searchValue)
      );
    } else {
      emptyAllManagers();
      setManagers([]);
      setManagersQueryString((prevQueryString) =>
        applyListSearchQuery(prevQueryString, searchValue)
      );
    }
  };

  //Handle change tab
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  //Empty allGroups and allManagers reducer when changing tab
  useEffect(() => {
    //Stop useEffect first rander property
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (activeTab === tabsNames.group) {
      emptyAllGroups();
      getGroupsByBrandId(
        { ...queryString, from: PAGINATION_INDEXING.FIRST_PAGE_INDEX },
        brandId
      );
    }
    if (activeTab === tabsNames.managers) {
      emptyAllManagers();
      getManagersByBrandId(
        {
          ...managersQueryString,
          from: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
        },
        brandId
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // Reset store profile
  useEffect(() => {
    resetRestaurantProfile();
    getStoreById(brandId);
    emptyAllGroups();
    emptyAllManagers();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid py-3">
      <div className="container-fluid pb-3">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 col-lg-3 px-0">
            <div className="input-group">
              <span className="input-group-text bg-white text-secondary">
                <FontAwesomeIcon icon={faSearch} />
              </span>
              <DebounceInput
                placeholder={
                  activeTab === tabsNames.group
                    ? BRAND_GROUPS_LABELS.SEARCH_GROUPS
                    : BRAND_GROUPS_LABELS.SEARCH_MANAGERS
                }
                type="text"
                className="form-control rounded-end"
                debounceTimeout={LIST_SEARCH_DEBOUNCE_MS}
                onChange={(e) => setSearchString(e)}
                value={
                  activeTab === tabsNames.group
                    ? queryString.search
                    : managersQueryString.search
                }
              />
              {(queryString.search.length > EMPTY_ARRAY_LENGTH &&
                activeTab === tabsNames.group) ||
              (managersQueryString.search.length > EMPTY_ARRAY_LENGTH &&
                activeTab === tabsNames.managers) ? (
                <span
                  role="button"
                  tabIndex={0}
                  className="user-input-reset"
                  aria-label="reset-search-field"
                  onClick={setSearch}
                  onKeyDown={(e) => {
                    onKeyDownHandler(e, () => {
                      setSearch();
                    });
                  }}
                >
                  <i className="fa fa-times" />
                </span>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="notification-form shadow card px-4 mb-3">
        <div className="tabs tabs--bordered-bottom">
          <Nav tabs className="mb-2">
            <NavItem className="cursor-pointer nav-pill-item">
              <NavLink
                className={classnames123({
                  active: activeTab === tabsNames.group,
                })}
                aria-label="group-button"
                onClick={() => toggleTab(tabsNames.group)}
              >
                {BRAND_GROUPS_LABELS.GROUPS}
              </NavLink>
            </NavItem>
            <NavItem className="cursor-pointer nav-pill-item">
              <NavLink
                className={classnames123({
                  active: activeTab === tabsNames.managers,
                })}
                aria-label="manager-button"
                onClick={() => toggleTab(tabsNames.managers)}
              >
                {BRAND_GROUPS_LABELS.MANAGERS}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="tab-content-diagnosis">
            <TabPane tabId={tabsNames.group}>
              <GroupsTab
                groups={groups}
                activeTab={activeTab}
                setGroups={setGroups}
                queryString={queryString}
                setQueryString={setQueryString}
              />
            </TabPane>
            <TabPane tabId={tabsNames.managers}>
              <ManagersTab
                managers={managers}
                activeTab={activeTab}
                setManagers={setManagers}
                queryString={managersQueryString}
                setQueryString={setManagersQueryString}
              />
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getStoreById: (brandId) => dispatch(storeActions.getStoreById(brandId)),
  getGroupsByBrandId: (queryString, brandId) =>
    dispatch(groupsActions.getGroupsByBrandId(queryString, brandId)),
  emptyAllGroups: () => dispatch(groupsActions.emptyAllGroups()),
  resetRestaurantProfile: () =>
    dispatch(individualStoreProfileActions.resetRestaurantProfile()),
  getManagersByBrandId: (queryString, brandId) =>
    dispatch(managersActions.getManagersByBrandId(queryString, brandId)),
  emptyAllManagers: () => dispatch(managersActions.emptyAllManagers()),
});

export default connect(null, mapDispatchToProps)(BrandGroups);
